import React, { useState } from 'react';
import Header from './Header';
import BottomNavigation from './BottomNavigation';

interface LayoutProps {
  children: React.ReactNode;
  activeSection: string;
  onSectionChange: (section: string) => void;
}

const Layout: React.FC<LayoutProps> = ({ children, activeSection, onSectionChange }) => {
  const [connectionStatus] = useState<'connected' | 'disconnected' | 'connecting'>('connected');

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-900 transition-colors">
      <Header connectionStatus={connectionStatus} />
      
      <main className="pb-20 sm:pb-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          {children}
        </div>
      </main>

      <BottomNavigation 
        activeSection={activeSection} 
        onSectionChange={onSectionChange} 
      />
    </div>
  );
};

export default Layout;